var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cv-skeleton-text',{staticClass:"ff-skeleton",attrs:{"paragraph":true,"line-count":_vm.lines,"width":'100%'}})}
var staticRenderFns = []

export { render, staticRenderFns }